// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2pp9u","mainHeading":"styles_mainHeading__29bs5","progressbarDiv":"styles_progressbarDiv__1U5UN","child":"styles_child__3KdCj"};